import PropTypes from "prop-types";
import React from "react";

import dragDropContext from "../../../util/drag-drop-context.js";
import DraggableTargetCard from "./draggable-target-card.js";

class DraggableContentList extends React.Component {
  static get displayName() {
    return "DraggableContentList";
  }

  static get propTypes() {
    return {
      items: PropTypes.array.isRequired,
      onReorderContent: PropTypes.func.isRequired,
      onDeleteContent: PropTypes.func.isRequired,
      onChangeContentDuration: PropTypes.func.isRequired,
    };
  }

  moveCard(dragIdx, hoverIdx) {
    const reorderedItems = this._reorder(this.props.items, dragIdx, hoverIdx);
    this.props.onReorderContent(reorderedItems);
  }

  _reorder(arr, startIndex, endIndex) {
    const reordered = Array.from(arr);
    const [removed] = reordered.splice(startIndex, 1);
    reordered.splice(endIndex, 0, removed);
    return reordered;
  }

  render() {
    return (
      <div className="content-drop-area">
        {this.props.items.map((item, idx) => (
          <DraggableTargetCard
            key={`${item.id}--${idx}`}
            index={idx}
            item={item}
            moveCard={this.moveCard.bind(this)}
            onDelete={this.props.onDeleteContent}
            onChangeDuration={this.props.onChangeContentDuration}
          />
        ))}
      </div>
    );
  }
}

module.exports = dragDropContext(DraggableContentList);
